import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { SvgIcons } from '@ngneat/svg-icon';
import { SubscriptionsService } from '../subscriptions.service';
import { UtilsService } from '../../../../core/services/utils.service';
import { Pagination, Subscription } from '../subscriptions.model';
import { TariffService } from '../../../../core/services/tariff.service';
import { Tariff, TariffId } from '../../tariff.model';
import { ActivateSubscriptionModalInputData } from '../../activate-subscription-modal/open-activate-subscription-modal.directive';
import { tariffsSubmenu } from '../../tariffs-submenu';
import { MetricsService } from '../../../../shared/metrics/metrics.service';
import { KkmAvailableOperations } from '../../../../core/modules/kkms/kkms.types';
import { SubscriptionFilter } from '../../../../core/modules/subscriptions/subscriptions.types';

@UntilDestroy()
@Component({
  selector: 'tax-subscriptions',
  templateUrl: 'subscriptions-page.component.html',
  styleUrls: ['subscriptions-page.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SubscriptionsPageComponent implements OnInit {
  readonly tabs = tariffsSubmenu;
  readonly trackByFn = this.utilsService.trackById;

  subscriptions: (Subscription & KkmAvailableOperations)[] = [];
  filter: SubscriptionFilter = {
    pagination: this.getPagination(),
  };

  tariffs: Record<TariffId, Tariff> = {};
  totalItems: number = 0;

  private readonly PAGE_SIZE = 10;

  constructor(
    private cdr: ChangeDetectorRef,
    private metricsService: MetricsService,
    private router: Router,
    private subscriptionsService: SubscriptionsService,
    private tariffService: TariffService,
    private utilsService: UtilsService,
  ) {}

  ngOnInit(): void {
    this.getSubscriptions();
    this.getTariffs();
  }

  getIconName(subscription: Subscription): SvgIcons {
    if (!subscription.regStatus) {
      return 'done';
    }

    if ([2, 6].includes(subscription.regStatus)
      // TODO: refactor
      || ([10].includes(subscription.regStatus) && subscription.billingStatus !== undefined && subscription.billingStatus !== 3)) {
      return 'time';
    }

    if ([7, 3].includes(subscription.regStatus)
      // TODO: refactor
      || ([5].includes(subscription.regStatus) && subscription.billingStatus !== undefined && subscription.billingStatus !== 3)) {
      return 'error';
    }

    return 'done';
  }

  getDataToSubscription(subscription: Subscription): ActivateSubscriptionModalInputData {
    return {
      // @ts-ignore
      kkmId: subscription.kkmId,
      // @ts-ignore
      tariff: this.tariffs[subscription.tariffId],
    };
  }

  getMoreSubscriptions(): void {
    this.filter.pagination = this.getPagination();

    this.subscriptionsService.getSubscriptions(this.filter)
      .pipe(untilDestroyed(this))
      .subscribe((subscriptionModel) => {
        this.subscriptions.push(...(subscriptionModel.subscriptions || []));
        this.cdr.detectChanges();
      });
  }

  getSubscriptions(filter: SubscriptionFilter = {}): void {
    this.filter = {
      ...filter,
      pagination: {
        from: 0,
        to: this.PAGE_SIZE - 1,
      },
    };

    this.subscriptionsService.getSubscriptions(this.filter)
      .pipe(untilDestroyed(this))
      .subscribe((subscriptionModel) => {
        this.subscriptions = subscriptionModel.subscriptions || [];
        this.totalItems = subscriptionModel.total || 0;
        this.cdr.detectChanges();
      });
  }

  goToSelectSubscriptionPage(kkmId: number | undefined): void {
    if (!kkmId) {
      return;
    }
    this.metricsService.ymGoal('Нажата кнопка изменения/выбора подписки');
    this.router.navigate(['/main/kkms/', kkmId, 'tariffs']);
  }

  updateAutoProlong(subscription: Subscription & KkmAvailableOperations): void {
    if (!subscription.availableOperations.toggleRenewal) {
      return;
    }

    this.subscriptionsService.kkmToggleRenewal(subscription.kkmId as number, !subscription.isAutoRenewableSubscription)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          subscription.isAutoRenewableSubscription = !subscription.isAutoRenewableSubscription;
          this.cdr.detectChanges();
        },
      });
  }

  private getPagination(): Pagination {
    return {
      from: this.subscriptions.length,
      to: this.subscriptions.length + this.PAGE_SIZE - 1,
    };
  }

  private getTariffs(): void {
    this.tariffService.getPublicTariffs()
      .pipe(untilDestroyed(this))
      .subscribe((tariffs) => {
        this.tariffs = tariffs.reduce((tariffsObject, tariff) => ({
          ...tariffsObject, [tariff.id]: tariff,
        }), {});
        this.cdr.detectChanges();
      });
  }
}
